export default "__VITE_ASSET__c043ff89__"